import { IS_CLINIC_APP } from "@/config/constants";
import { ORGANIZATION_TYPE, OrganizationType } from "@/types/organization";

const CURRENCIES = {
  USD: { value: "USD", label: "USD - US Dollar" },
  NPR: { value: "NPR", label: "NPR - Nepalese Rupee" },
  AED: { value: "AED", label: "AED - UAE Dirham" },
};

// Order only - the selected default still comes from the detected timezone.
// ClinicPilot sells into the UAE first, so AED leads its list.
export const CURRENCY_OPTIONS: Array<{ value: string; label: string }> =
  IS_CLINIC_APP
    ? [CURRENCIES.AED, CURRENCIES.USD, CURRENCIES.NPR]
    : [CURRENCIES.USD, CURRENCIES.NPR, CURRENCIES.AED];

export const ORGANIZATION_TYPE_OPTIONS: Array<{
  value: OrganizationType;
  label: string;
  description: string;
  icon: string;
}> = [
  {
    value: ORGANIZATION_TYPE.CLINIC,
    label: "Clinic / Healthcare",
    description: "Manage treatments, doctors, and patient communications",
    icon: "solar:hospital-linear",
  },
  {
    value: ORGANIZATION_TYPE.ECOMMERCE,
    label: "E-commerce / Retail",
    description: "Manage products, orders, and customer communications",
    icon: "solar:cart-large-2-linear",
  },
];

// The build already knows which product it is, so asking is a question with one
// right answer. The picker survives in dev only, to reach the other branch.
export const DEFAULT_ORGANIZATION_TYPE: OrganizationType = IS_CLINIC_APP
  ? ORGANIZATION_TYPE.CLINIC
  : ORGANIZATION_TYPE.ECOMMERCE;

// "Business" over "Store" on the general build: the ecommerce default is only
// there because the enum has two values, and a salon or agency on Replyn is
// not a store. One string to flip if that stops being true.
export const ORGANIZATION_NAME_FIELD = IS_CLINIC_APP
  ? { label: "Clinic name", placeholder: "Bright Smile Dental", noun: "clinic" }
  : { label: "Business name", placeholder: "Acme Co.", noun: "business" };
